'use client';

const selectAnnouncementOptions = {
  id: "chalk-select"
};
export {
  selectAnnouncementOptions
};
